<template>
  <v-container>
    <v-row no-gutters>
      <v-col>
        <v-text-field
          class="text-h5"
          id="environments__current-name"
          solo
          flat
          dense
          persistent-hint
          :readonly="!environment_manager"
          v-model="currentEnvironmentName"
          :title="
            !environment_manager
              ? null
              : $t('modules.environments.current.nameEditTooltip')
          "
          :hint="$t('modules.environments.current.name')"
        />
      </v-col>
      <v-scroll-x-transition>
        <v-col v-if="currentEnvironmentNameChanged">
          <v-btn
            class="mx-1"
            color="secondary"
            text
            elevation="1"
            @click="save()"
            id="environments__current-save"
            >{{ $t("actions.save") }}
          </v-btn>
          <v-btn
            class="mx-1"
            color="secondary"
            text
            elevation="1"
            @click="cancel()"
            id="environments__current-cancel"
            value=""
            >{{ $t("actions.cancel") }}
          </v-btn>
        </v-col>
      </v-scroll-x-transition>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { handleError } from "@/utils/error";

export default {
  name: "CurrentEnvironment",
  mounted() {
    this.clearCurrentEnvironmentName();
  },

  computed: {
    ...mapGetters("environments", ["currentEnvironmentNameChanged"]),

    environment_manager() {
      return this.$store.state.login.user.environment_manager;
    },

    currentEnvironmentName: {
      get() {
        return this.$store.state.environments.currentEnvironment.name;
      },
      set(value) {
        this.$store.commit("environments/updateCurrentEnvironmentName", value);
      }
    },

    currentEnvironmentId() {
      return this.$store.state.environments.currentEnvironment.id;
    }
  },

  methods: {
    clearCurrentEnvironmentName() {
      this.$store.dispatch("environments/fetchCurrentEnvironment");
    },
    save() {
      this.$store.dispatch("loader/startLoading");
      const data = {
        id: this.currentEnvironmentId,
        name: this.currentEnvironmentName
      };
      this.$store.dispatch("environments/update", data).catch(error => {
        handleError(error);
      });
    },
    cancel() {
      this.clearCurrentEnvironmentName();
    }
  }
};
</script>

<style></style>
